module.exports = __webpack_public_path__ + "static/media/mixcloud.a5f9367d.svg";